import clsx from "clsx";
import makeStyles from "@mui/styles/makeStyles";

import { FULL_DAYS } from "../../consts/strings";
import { palette } from "../../theme/palette";
import { View } from "../View";

const useStyles = makeStyles({
  container: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    marginTop: "-0.2rem",
  },
  inline: {
    display: "flex",
    flexDirection: "row",
    marginTop: "4px",
  },
  text: {
    fontSize: "12px",
    color: palette.typography.white.high,
    lineHeight: "16px",
  },
  headerContainer: {
    display: "flex",
    flexDirection: "row",
  },
  headerLeftContainer: {
    marginRight: "0.35rem",
  },
  headerRightContainer: {
    width: "11rem",
  },
});

export const ShiftManagerDayRow = ({ dayOfWeek, sectionName }) => {
  const styles = useStyles();
  return (
    <View className={clsx(styles.text, styles.inline)}>
      <View className={styles.headerContainer}>
        <View className={styles.headerLeftContainer}>
          {`${FULL_DAYS[dayOfWeek]}: `}
        </View>
        <View className={styles.headerRightContainer}>
          {sectionName || "« no section »"}
        </View>
      </View>
    </View>
  );
};

export const ShiftManagerCardContent = ({ shiftManager }) => {
  const styles = useStyles();

  return (
    <View className={styles.container}>
      {shiftManager.sections.map(({ dayOfWeek, sectionName }) => (
        <View key={dayOfWeek}>
          <ShiftManagerDayRow dayOfWeek={dayOfWeek} sectionName={sectionName} />
        </View>
      ))}
    </View>
  );
};
